module.exports = __webpack_public_path__ + "static/media/113.74a69bf4.jpg";